
import Vue from "vue";
import { Constantes } from "@/Util/Constantes";
import { AutoCompleteTemplate, Utilidades } from "@/Util/Utilidades";
import { ComboService } from "@/services/ComboService";
export default Vue.extend({
  name: "Autocomplete",
  props: {
    label: String,
    tag: String,
    items: {
      default: null,
      type: Array,
    },
    rules: Array,
    disabled: Boolean,
    readonly: Boolean,
    reverse: Boolean,
    loading: Boolean,
    width: String,
    hint: {
      type: [String, Number],
      default: "",
    },
    clase: String,
    placeholder: String,
    itemText: String,
    itemValue: String,
    multiple: Boolean,
    smallChips: Boolean,
    deletableChips: Boolean,
    persistent_hint: Boolean,
    returnObject: Boolean,
    value: [String, Number, Array, Object],
    seleccionar_uno: {
      type: Boolean,
      default: true,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
    },
    id_tabla: String,
    filtro: {
      default: "",
      type: String,
    },
    cargar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valor: null,
      deshabilitado: false,
      itemsAux: new Array<any>(),
      loadingAux: false as boolean,
    };
  },
  computed: {
    hasNuevoSlot(): boolean {
      let val = !!this.$slots.nuevo;

      return val;
    },
  },
  async mounted() {
    if (this.cargar) {
      await this.cargarCombo();
    }
  },
  methods: {
    getWidth() {
      if (!Utilidades.isNullOrUndefinedOrEmpty(this.width)) {
        return "width:" + this.width + " !important";
      } else {
        return "";
      }
    },
    getSinDatos() {
      return Constantes.SIN_DATOS;
    },
    async change() {
      await Utilidades.sleep(50);
      this.$emit("change");
    },
    async keydown(evento) {
      await Utilidades.sleep(50);
      this.$emit("keydown", evento);
    },
    async blur() {
      await Utilidades.sleep(50);
      this.$emit("blur");
    },
    async cargarCombo() {      
      if (Utilidades.isNullOrUndefinedOrEmpty(this.id_tabla)) {
        return;
      }

      if (Utilidades.isNullOrUndefinedOrEmpty(this.itemText)) {
        this.loadingAux = true;

        this.itemsAux = new Array<AutoCompleteTemplate>();

        this.itemsAux = await ComboService.getComboAsync(
          this.id_tabla,
          this.filtro
        );

        this.loadingAux = false;
      } else {
        this.loadingAux = false;

        await ComboService.getComboRaw(this.id_tabla, this.filtro)
          .then((x) => {
            this.itemsAux = new Array<any>();
            this.itemsAux = x.data;
          })
          .catch(() => {
            Utilidades.Message({
              message: Constantes.ERROR_CARGAR_DATOS,
              error: true,
            });
          })
          .finally(() => {
            this.loadingAux = false;
          });
      }
    },
  },
  watch: {
    valor: {
      //immediate: true,
      handler(novoValor) {
        this.$emit("input", novoValor);
      },
    },
    value: {
      immediate: true,
      handler(val) {
        this.valor = val;
      },
    },
    items: {
      immediate: true,
      handler(items) {
        if (items) {
          if (items.length == 1 && this.seleccionar_uno) {
            if (this.itemValue) {
              this.valor = items[0][this.itemValue];
            } else {
              this.valor = items[0].value;
            }
            this.deshabilitado = true;
            this.$emit("change", this.valor);
          }else{
            this.deshabilitado = false;
          }
        }
      },
    },
    filtro: {
      immediate: true,
      handler(val) {
        if (!Utilidades.isNullOrUndefinedOrEmpty(val) && !this.loadingAux) {
          this.cargarCombo();
        }
      },
    },
  },
});
